import React from 'react'
import ReactDOM from 'react-dom/client'
import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { RiCheckboxCircleLine } from 'react-icons/ri'
import {
  CampaignDetails,
  CampaignDestination,
  FinalPage,
} from '../components/NewTracker/Index'
import '../layouts/stylesheets/new-tracker-page-style.css'
import SideMenu from '../layouts/SideMenu'
import MenuWrap from '../components/BurgerMenu/MenuWrap'

import { ReactComponent as BackIcon } from '../assets/back-button.svg'
import { ReactComponent as ForwardIcon } from '../assets/forward-button.svg'

const EditTrackerPage = () => {
  const location = useLocation()

  const [activePage, setActivePage] = useState('campaignDetails')
  const [campaignData, setCampaignData] = useState({})
  const [oldCampaignData] = useState(location.state.data)
  const [nav, setNav] = useState('')

  // SVG içinde path'e tıklanınca da doğru id gelsin diye currentTarget.id
  const handleNav = async (event) => {
    const id = event?.currentTarget?.id
    if (id) setNav(id)
  }

  const root = useRef()
  const progressBar = useRef()

  useEffect(() => {
    if (activePage !== 'finalPage') {
      let order = {}
      if (!root.current) {
        root.current = ReactDOM.createRoot(progressBar.current)
      }
      order.campaignDetails = 0
      order.campaignDestination = 1

      const gridProps = { className: 'grid' }
      // Tailwind not detecting class dynamically so had to add class like this.
      if (Object.keys(order).length === 2) {
        gridProps.className = gridProps.className + ' grid-cols-2'
      }
      const activePageOrder = order[activePage]
      let container = []
      for (let i = 0; i < Object.keys(order).length; i++) {
        const props = {
          className: 'flex justify-center items-center col-span-1',
          key: i,
        }
        if (i <= activePageOrder) {
          container.push(
            React.createElement(
              'div',
              props,
              React.createElement(
                'div',
                { className: 'nav-dot flex items-center justify-center' },
                React.createElement(RiCheckboxCircleLine, {
                  className: 'text-white w-2/3 h-2/3',
                })
              )
            )
          )
        } else {
          container.push(
            React.createElement(
              'div',
              props,
              React.createElement('div', { className: 'nav-dot' })
            )
          )
        }
      }
      const containerGrid = React.createElement('div', gridProps, container)
      root.current.render(containerGrid)
    } else {
      root.current.render('')
    }
  }, [activePage])

  console.log(campaignData)
  return (
    <div id="outer-container" style={{ height: '100%' }}>
      <MenuWrap className="sm:hidden">
        <SideMenu isAuthorized={true}></SideMenu>
      </MenuWrap>
      <div id="page-wrap">
        <div className="flex">
          <SideMenu isAuthorized={true} className="hidden sm:block"></SideMenu>
          <div className="w-full">
            <div className="grid grid-cols-12 h-screen">
              <div className="flex items-center justify-start col-start-1">
                {activePage === 'campaignDestination' && (
                  <BackIcon
                    id="back"
                    onClick={handleNav}
                    className="cursor-pointer"
                    aria-label="Back"
                    role="img"
                  />
                )}
              </div>
              <div
                className="flex justify-center items-center md:h-[calc(100vh-200px)] col-start-2 col-end-12"
                aria-live="polite"
              >
                {activePage === 'campaignDetails' && (
                  <CampaignDetails
                    nav={nav}
                    pageType="edit"
                    setNav={setNav}
                    setActivePage={setActivePage}
                    campaignData={campaignData}
                    oldCampaignData={oldCampaignData}
                    setCampaignData={setCampaignData}
                  ></CampaignDetails>
                )}
                {activePage === 'campaignDestination' && (
                  <CampaignDestination
                    nav={nav}
                    pageType="edit"
                    setNav={setNav}
                    setActivePage={setActivePage}
                    oldCampaignData={oldCampaignData}
                    campaignData={campaignData}
                    setCampaignData={setCampaignData}
                  ></CampaignDestination>
                )}
                {activePage === 'finalPage' && (
                  <FinalPage
                    nav={nav}
                    setNav={setNav}
                    setActivePage={setActivePage}
                    campaignData={campaignData}
                    setCampaignData={setCampaignData}
                  ></FinalPage>
                )}
              </div>
              <div className="flex items-center justify-end col-start-12">
                {activePage !== 'finalPage' && (
                  <ForwardIcon
                    id="forward"
                    onClick={handleNav}
                    className="cursor-pointer"
                    aria-label="Forward"
                    role="img"
                  />
                )}
              </div>
              <div
                id="progressBar"
                ref={progressBar}
                className="col-start-4 col-end-10"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditTrackerPage
